module.exports = __webpack_public_path__ + "static/media/sw-collage.aae6c0c5.jpg";